import { ProductIds } from '../constants/productIds';

export enum TutorialStatus {
  Pending = "pending",
  Approved = "approved",
  InProgress = "in-progress",
  Published = "published",
  NotApplicable = "not-applicable",
}

export interface Tutorial {
  id: string;
  youtubeUrl?: string;
  title: string;
  duration?: string;
  thumbnailUrl?: string;
  productIds?: ProductIds[];
  isActive: boolean;
  createdAt: number;
  createdBy: string;
  status?: TutorialStatus;
  notifyByEmail?: boolean;
  email?: string;
  message?: string;
}

export type CreateTutorialPayload = Omit<
  Tutorial,
  'id' | 'createdAt' | 'createdBy'
>;

export type UpdateTutorialPayload = Partial<Tutorial> & {
  lastUpdatedAt?: number;
  lastUpdateBy?: string;
};

export interface CreateTutorialSuggestionPayload {
  title: string;
  message: string;
  notifyByEmail: boolean;
  email?: string;
  productIds?: ProductIds[];
}
